import React from 'react';
import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import { Tools, StickiesFill, StarFill } from 'react-bootstrap-icons';

const Roadmap = () => {
    return (
        <VerticalTimeline>
            <VerticalTimelineElement
                iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
                icon={<StarFill />}
            />
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                date="4Q 2021"
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<Tools />}
            >
                <h4 className="vertical-timeline-element-title">Metaframe is born</h4>
                <p>
                    Initial thoughts of the Metaframe project is discussed.
                </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                contentArrowStyle={{ borderRight: '7px solid  rgb(33, 150, 243)' }}
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<Tools />}
            >
                <h4 className="vertical-timeline-element-title">Metaframe Deployed</h4>
                <p>
                    Metaframe is deployed to the blockchain.<br/>
                    First and Major steps are made.
                </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<Tools />}
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            >
                <h4 className="vertical-timeline-element-title">Website Created</h4>
                <p>
                    Website is created to expose the project to the world.
                </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date="1Q 2024"
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<Tools />}
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            >
                <h4 className="vertical-timeline-element-title">Phase 0</h4>
                <p>
                    Metaframe alpha version launched. Decentralized app tests initiated.
                </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--work"
                date="2Q 2024"
                iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
                icon={<StickiesFill />}
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            >
                <h4 className="vertical-timeline-element-title">Phase I</h4>
                <p>
                    Schedule fo the completion of beta version of the decentralized app. We will collecting reports about the user experience, visual design and testing.
                </p>
            </VerticalTimelineElement>
            <VerticalTimelineElement
                className="vertical-timeline-element--education"
                date="3Q 2024"
                iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
                icon={<StickiesFill />}
                contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
            >
                <h4 className="vertical-timeline-element-title">Phase II</h4>
                <p>
                    Scheduled the phase II of the project. The decentralized app is ready to be launched as GA product.
                </p>
            </VerticalTimelineElement>

        </VerticalTimeline>
    );
}
export default Roadmap;